import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@kontentino/ui';
import { faImage } from '@fortawesome/pro-regular-svg-icons/faImage';

interface Props {
  variant:
    | 'no-files'
    | 'no-results'
    | 'album-not-found'
    | 'no-shared-albums'
    | 'unavailable';
  cta?: ReactNode;
}

const EmptyState: FC<Props> = ({ variant, cta }) => {
  const { t } = useTranslation();
  const titleKey =
    variant === 'no-results'
      ? 'mediaLibrary.page.noResults.title'
      : variant === 'album-not-found'
      ? 'mediaLibrary.page.albumNotFound.title'
      : variant === 'no-shared-albums'
      ? 'mediaLibrary.sharedAlbums.empty.title'
      : 'mediaLibrary.page.empty.title';
  const descKey = titleKey.replace('.title', '.description');

  return (
    <div
      className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-py-20 tw-text-center"
      data-cy="media-library_empty"
    >
      <Icon icon={faImage} />
      {variant === 'unavailable' ? (
        <h3 className="tw-max-w-md tw-text-lg tw-font-medium">
          {t('mediaLibrary.page.noMainAlbum')}
        </h3>
      ) : (
        <>
          <h3 className="tw-text-lg tw-font-medium">{t(titleKey)}</h3>
          <p className="tw-max-w-md tw-text-sm tw-text-grayscale-100">
            {t(descKey)}
          </p>
        </>
      )}
      {cta}
    </div>
  );
};

export default EmptyState;
